'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _intersperse = require('linksoft/utils/intersperse');

var _intersperse2 = _interopRequireDefault(_intersperse);

var _config = require('linksoft/core/config');

var _config2 = _interopRequireDefault(_config);

var _linksoftAlbatros = require('linksoft-albatros');

var _pickBy2 = require('lodash/pickBy');

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _author = require('../components/author');

var _author2 = _interopRequireDefault(_author);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartItem = function (_Component) {
    (0, _inherits3.default)(CartItem, _Component);

    function CartItem(props) {
        (0, _classCallCheck3.default)(this, CartItem);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartItem.__proto__ || (0, _getPrototypeOf2.default)(CartItem)).call(this, props));

        _this.handleDelete = function () {
            _this.props.submitChanges({ productId: _this.props.data.productId, amount: 0 });
        };

        _this.onImageError = function (e) {
            _this.setState({ imageUrl: '/Content/images/img-placeholder-big.jpg' });
        };

        _this.state = {
            imageUrl: (0, _config2.default)().url.productImage({ id: props.data.productId })
        };
        return _this;
    }

    (0, _createClass3.default)(CartItem, [{
        key: 'render',
        value: function render() {
            var _pickBy = (0, _pickBy3.default)(this.props.data),
                _pickBy$productId = _pickBy.productId,
                productId = _pickBy$productId === undefined ? '' : _pickBy$productId,
                _pickBy$productName = _pickBy.productName,
                productName = _pickBy$productName === undefined ? '' : _pickBy$productName,
                _pickBy$authors = _pickBy.authors,
                authors = _pickBy$authors === undefined ? [] : _pickBy$authors,
                _pickBy$amount = _pickBy.amount,
                amount = _pickBy$amount === undefined ? 0 : _pickBy$amount,
                _pickBy$amountAvailab = _pickBy.amountAvailable,
                amountAvailable = _pickBy$amountAvailab === undefined ? 0 : _pickBy$amountAvailab,
                _pickBy$totalAmountAv = _pickBy.totalAmountAvailable,
                totalAmountAvailable = _pickBy$totalAmountAv === undefined ? 0 : _pickBy$totalAmountAv,
                _pickBy$price = _pickBy.price,
                price = _pickBy$price === undefined ? {} : _pickBy$price,
                _pickBy$commission = _pickBy.commission,
                commission = _pickBy$commission === undefined ? false : _pickBy$commission;

            var canChangeCart = this.props.canChangeCart;

            return _react2.default.createElement(
                'tr',
                { className: 'miniCartProduct' },
                _react2.default.createElement(
                    'td',
                    { style: { width: "20%" }, className: 'text-center' },
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: (0, _config2.default)().url.product({ id: productId }) },
                            _react2.default.createElement('img', { src: this.state.imageUrl, onError: this.onImageError, alt: 'img' })
                        )
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'table-view--title-name' },
                    _react2.default.createElement(
                        'div',
                        { className: 'miniCartDescription' },
                        _react2.default.createElement(
                            'a',
                            { className: 'title', href: (0, _config2.default)().url.product({ id: productId }) },
                            productName
                        ),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'span',
                            { className: 'authors' },
                            (0, _intersperse2.default)(authors.map(function (author) {
                                return _react2.default.createElement(_author2.default, { key: 'author_' + (author.typeId || author.TypeRef) + '_' + (author.id || author.Id), data: author });
                            }), ", ")
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'price' },
                            _react2.default.createElement(
                                'span',
                                null,
                                (0, _linksoftAlbatros.formatPrice)(price.unitPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice) + '/' + (0, _localize2.default)("App:AmountPreOrder")
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'v-align-m' },
                    _react2.default.createElement(
                        'div',
                        { className: 'product-icon-group', 'data-tooltip-placements': 'left' },
                        !commission ? _react2.default.createElement('span', { className: 'product-icon product-icon-f product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:OrderType_Invoice') }) : null,
                        amount > amountAvailable && amount <= totalAmountAvailable ? _react2.default.createElement('span', { className: 'product-icon product-icon-c product-icon--small', 'data-toggle': 'tooltip',
                            'data-original-title': (0, _localize2.default)('App:LongerDelivery') }) : null
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'v-align-m text-right' },
                    amount + ' ' + (0, _localize2.default)("App:AmountPreOrder")
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'v-align-m text-right', style: { width: "22%" } },
                    _react2.default.createElement(
                        'span',
                        { className: 'price' },
                        (0, _linksoftAlbatros.formatPrice)(price.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                    ),
                    canChangeCart ? _react2.default.createElement(
                        'a',
                        { onClick: this.handleDelete },
                        _react2.default.createElement('i', { className: 'fa fa-remove' })
                    ) : ''
                )
            );
        }
    }]);
    return CartItem;
}(_react.Component);

CartItem.propTypes = {
    data: _propTypes2.default.object.isRequired,
    canChangeCart: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactRedux.connect)(null, {
    submitChanges: _actions2.default.submitChanges
})(CartItem);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/CartItem.js
// module id = 901
// module chunks = 0